/**
 * 下游企业详情（/company-detail）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 *
 * 注意：本页按路由参数 :id 渲染「不同企业」的数据（company.* 来自 @/data/companyNetwork），
 * 这些属于「逐企业」的动态数据，无法用单一 scope 字段覆盖所有企业，故保留绑定 company.* 不迁移；
 * 本模型只承接「与具体企业无关」的静态展示文案 + 页面背景图。
 */
export default {
  title: '下游企业详情',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'backText', label: '返回按钮文字', type: 'text', default: '返回' },
        { key: 'provSuffix', label: '省份后缀（企业简称后的"省"）', type: 'text', default: '省' },
      ],
    },
    {
      title: '主体内容 · 左栏（产品图片）',
      fields: [
        { key: 'mediaBadge', label: '产品图片角标', type: 'text', default: '产品形态' },
        { key: 'mediaCapTitle', label: '产品图片说明标题', type: 'text', default: '产品图片' },
      ],
    },
    {
      title: '主体内容 · 右栏（四大板块）',
      fields: [
        { key: 'cardTitleProduction', label: '板块①标题 · 生产动向', type: 'text', default: '生产动向' },
        { key: 'cardTitlePatent', label: '板块②标题 · 专利及发展方向', type: 'text', default: '专利及发展方向' },
        { key: 'cardTitleFuture', label: '板块③标题 · 产品未来', type: 'text', default: '产品未来' },
        { key: 'cardTitleInvest', label: '板块④标题 · 投资方向', type: 'text', default: '投资方向' },
        { key: 'chipDownstream', label: '下游应用标签文案', type: 'text', default: '酪蛋白酸钠下游应用' },
      ],
    },
    {
      title: '页脚',
      fields: [
        { key: 'footerSource', label: '数据来源说明', type: 'textarea', default: '数据来源：企业公开工商 / 专利 / 环评 / 项目备案 / 年报 / 行业公开资讯推演，仅供市场调研与数字看板展示' },
      ],
    },
    {
      title: '兜底状态',
      fields: [
        { key: 'emptyText', label: '未找到企业提示', type: 'text', default: '未找到对应企业，请返回重新选择。' },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认渐变）', type: 'image', default: '' },
      ],
    },
  ],
}
